import { message } from "antd";
import { AnyAction } from "redux";
import { createAction } from "redux-actions";
import { ThunkDispatch } from "redux-thunk";
import { ExaminationService } from "../../../api/base/examination/examination";
import { OrganizationService } from "../../../api/base/organization/organization";
import { PersonaService } from "../../../api/base/persona/persona";
import { FootSide, ScannerService, UpdateReportInsoleModelRequest } from "../../../api/scanner/scanner_service";
import { isHasBasicInfo } from "../../../javascripts/generic";
import { post, url } from "../../../javascripts/http";
import { RootState } from "../../reducers";
import { actionLogoutSuccess } from "../user";
import { PressureServiceShell } from "../../../api/algorithm/pressure/v2/pressure_service_shell"
import { returnArchAndSplay } from "../../../javascripts/utils";
import _ from 'lodash'
import { 
    formatGetInsoleModelRequest,
    formatGetInsoleModelToString,
    formatInsoleModelDataToPx 
} from "../../../javascripts/formatInsoleData";

let examinationService = new ExaminationService(url, post);
let organizationService = new OrganizationService(url, post);
let personalService = new PersonaService(url, post);
let scannerService = new ScannerService(url, post);
let pressureServiceShell = new PressureServiceShell(url, post);

// 机构 报告列表
export function actionGetReportListEntryIns (data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return false;
        }
        message.loading('数据加载中...', 0);
        try {

            // 获取组织组下的组织
            // console.log(data);
            let groupId = getState().user.orgGroupId;
            let res_org = await organizationService.getOrganizationsByOrganizationGroupIds({
                organizationGroupIds: [+groupId]
            });
            let orgGroupList = res_org.organizationGroupList[0].organizationList || [];

            let orgIds = orgGroupList.map((item) => {
                return item.id;
            }) || [];

            if(orgIds.length <= 0) {
                message.destroy();
                return 0;
            }
            let reqData = {
                pageNum: data.pageNum - 1,
                pageSize: data.pageSize,
                storeIdList: orgIds,
                examinationReportIdList: [],
                mobileNumberList: [],
                nickname: [],
                serialNumberList: []
            } as any;
            if(data.examinationReportId) {
                reqData.examinationReportIdList = [data.examinationReportId.trim()];
            }
            if(data.mobileNumber) {
                reqData.mobileNumberList = [data.mobileNumber.trim()];
            }
            if(data.nickname) {
                reqData.nickname = [data.nickname.trim()];
            }
            if(data.serialNumber) {
                reqData.serialNumberList = [data.serialNumber.trim()];
            }
            let resScan = await scannerService.pageListReport(reqData)
            
            dispatch(actionGetReportListEntryInsSuccess({
                data: resScan
            }))
        } catch (error) {
            console.log(error)
        }
        message.destroy();
    }
}

export const ACTION_GETREPORTLISTENTRYINS_SUCCESS = 'USER.ACTION_GETREPORTLISTENTRYINS_SUCCESS'

export interface ActionGetReportListEntryInsPayload {
    data: any
}

export const actionGetReportListEntryInsSuccess = createAction(
    ACTION_GETREPORTLISTENTRYINS_SUCCESS,
    (payload: ActionGetReportListEntryInsPayload) => {
        return payload;
    }
)


// 报告列表 分析中 数据采集中 5s 拉取数据
export function actionGetReportStatus () {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return false;
        }
        try {
           
            let data = getState().report.reportList || {};
            let scan = _.cloneDeep(data);
            if(!scan.reportList.length) return;

            let reportList = scan.reportList || [];
            let ticketList: any[] = [];
            reportList.map((item) => {
                if(item.state === 'PROCESSING' || item.state === 'COLLECTING') {
                    ticketList.push(item.ticket);
                    
                }
            })
            if(!ticketList.length) return;
            console.log(ticketList.length);

            // message.loading('状态刷新中...', 0);
            let resScan = await scannerService.listReport({
                ticketList: ticketList,
            } as any)
            let listStatus = resScan.reportList || [];
            reportList = reportList.map((item) => {
                let status = listStatus.find((s) => {
                    return s.ticket === item.ticket;
                });
                if(status && status.state) {
                    item.state = status.state;
                }
                return item;
            })

            scan.reportList = reportList;

            dispatch(actionGetReportStatusSuccess({
                data: scan
            }))
        } catch (error) {
            console.log(error)
        }
        message.destroy();
    }
}

export const ACTION_GETREPORTSTATUS_SUCCESS = 'USER.ACTION_GETREPORTSTATUS_SUCCESS'

export interface ActionGetReportStatusPayload {
    data: any
}

export const actionGetReportStatusSuccess = createAction(
    ACTION_GETREPORTSTATUS_SUCCESS,
    (payload: ActionGetReportStatusPayload) => {
        return payload;
    }
)

// 机构 报告详情
export function actionGetReportDetailEntryIns (data, isLeap?) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return false;
        }
        message.loading('数据加载中...', 0);
        try {

            // 设置鞋垫初始为空
            dispatch(actionSaveInsoleModel({
                left: {},
                right: {},
            }))

            let res = await examinationService.getExaminationReportByExamineeReportDetailId({
                examineeReportDetailId: data
            });
            let report = res.examinationReportResult || {};

            if(report.organizationId) {
                let res_org = await organizationService.getOrganizationByIds({
                    ids: [report.organizationId]
                });
                if(res_org.organizations.length) {
                    let obj = {
                        ...report,
                        orgName: res_org.organizations[0].name,
                        org: res_org.organizations[0]
                    };
                    report = obj;
                }
            }
            let insoleModel = {
                left: {},
                right: {},
            };
            let shoeSizeList = {
                left: [] as any,
                right: [] as any,
            }
            if(report) {
                let res_report = await scannerService.getReportByTicket({
                    ticket: report.examineeReportDetailId
                });
                if(res_report.report) {
                   
                    Object.assign(report, {detail: res_report.report});

                    if(res_report.report.shoesCustomization && isLeap) {
                        const leftInsoleModel = res_report.report.shoesCustomization.leftInsoleModel || {};
                        const rightInsoleModel = res_report.report.shoesCustomization.rightInsoleModel || {};
                        insoleModel = res_report.report.shoesCustomization.originModelInsoleData || {};
                        if(leftInsoleModel.url) {
                            insoleModel.left = {
                                ...leftInsoleModel,
                            }
                        }
                        if(rightInsoleModel.url) {
                            insoleModel.right = {
                                ...rightInsoleModel,
                            }
                        }
                        let shoeSizeListRight = await returnShoeSizeList({
                            ...insoleModel.right,
                            footSide: FootSide.RIGHT,
                        });
                        let shoeSizeListLeft = await returnShoeSizeList({
                            ...insoleModel.left,
                            footSide: FootSide.LEFT,
                        });
                        shoeSizeList = {
                            left: shoeSizeListLeft,
                            right: shoeSizeListRight,
                        }
                        dispatch(actionSaveInsoleModel(insoleModel))
                    }
                    
                }
            }

            dispatch(actionGetReportDetailEntryInsSuccess({
                data: report,
                shoeSizeList: shoeSizeList,
                insoleModelState: insoleModel,
            }))
        } catch (error) {
            console.log(error)
        }
        message.destroy()
    }
}

export const ACTION_GETREPORTDETAILENTRYINS_SUCCESS = 'USER.ACTION_GETREPORTDETAILENTRYINS_SUCCESS'

export interface ActionGetReportDetailEntryInsPayload {
    data: any
    shoeSizeList: any
    insoleModelState: any
}

export const actionGetReportDetailEntryInsSuccess = createAction(
    ACTION_GETREPORTDETAILENTRYINS_SUCCESS,
    (payload: ActionGetReportDetailEntryInsPayload) => {
        return payload;
    }
)

// 获取足弓范围
export function actionGetFootArchValueRange () {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return false;
        }
        message.loading('数据加载中...', 0);
        try {

            let res = await pressureServiceShell.getFootArchValueRange({});
            dispatch(actionGetFootArchValueRangeSuccess({
                data: res.ranges || [],
            }))
        } catch (error) {
            console.log(error)
        }
        message.destroy()
    }
}

export const ACTION_GETFOOTARCHVALUERANGE_SUCCESS = 'USER.ACTION_GETFOOTARCHVALUERANGE_SUCCESS'

export interface ActionGetFootArchValueRangePayload {
    data: any
}

export const actionGetFootArchValueRangeSuccess = createAction(
    ACTION_GETFOOTARCHVALUERANGE_SUCCESS,
    (payload: ActionGetFootArchValueRangePayload) => {
        return payload;
    }
)

async function returnShoeSizeList (rightInsoleModel) {
    let rightLength = +rightInsoleModel.length;
    let rightLengthArr = [
        rightLength - 10, rightLength - 5, 
        rightLength, 
        rightLength + 5, rightLength + 10,
    ];
    let res_shoeRight = await scannerService.listInsoleModel({
        lengthList: rightLengthArr,
        medialLongitudinalArchHighList: [rightInsoleModel.medialLongitudinalArchHigh],
        medialLongitudinalArchPositionList: [rightInsoleModel.medialLongitudinalArchPosition],
        inEvertionList: [rightInsoleModel.inEvertion],
        footSideList: [rightInsoleModel.footSide],
    } as any)


    let arr: any[] = [];
    rightLengthArr.map((item) => {
        let obj = res_shoeRight.insoleModelList.find((s: any) => {
            return s.length == item;
        });

        if(item !== 220){
            if(obj && obj.shoeSize) {
                arr.push({
                    length: item,
                    shoeSize: obj.shoeSize,
                });
            }
            else {
                arr.push({
                    length: item,
                    shoeSize: 0,
                });
            }
        }
    });

    return arr;
}

// 左右脚模型参数
export function actionSaveInsoleModel (data, direction?) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return false;
        }
        message.loading('数据加载中...', 0);
        try {
           
            let insoleLeft = formatInsoleModelDataToPx(data.left);
            let insoleRight = formatInsoleModelDataToPx(data.right);
            let insoleModel = {
                left: {
                    ...data.left,
                    ...insoleLeft,
                },
                right: {
                    ...data.right,
                    ...insoleRight,
                },
            }

            dispatch(actionSaveInsoleModelSuccess({
                data: insoleModel,
                updateInsoleStl: direction ? true : false,
            }))

        } catch (error) {
            console.log(error)
        }
        message.destroy()
    }
}

export const ACTION_SAVEINSOLEMODEL_SUCCESS = 'USER.ACTION_SAVEINSOLEMODEL_SUCCESS'

export interface ActionSaveInsoleModelPayload {
    data: any,
    updateInsoleStl: boolean
}

export const actionSaveInsoleModelSuccess = createAction(
    ACTION_SAVEINSOLEMODEL_SUCCESS,
    (payload: ActionSaveInsoleModelPayload) => {
        return payload;
    }
)

// 压力报告
export function actionGetReportPressure (data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return false;
        }
        message.loading('数据加载中...', 0);
        try {

            // let str = window.location.pathname.replace('/report/', '');
            let arr = data.split('+');
            if(arr.length < 2) return ;
            // console.log(str, arr)
            let pressureDynamicId = arr[0];
            let examineeId = +arr[1];
            let pressureBalanceId = arr[2];

            let res_info = await examinationService.getExamineeById({
                examineeId: examineeId
            })

            let res_report = await pressureServiceShell.getPressureDynamicReport({
                ticket: pressureDynamicId
            });

            let obj = {};
            let sdata = res_report;
            if(sdata.report && sdata.report.valid) {
                obj = returnArchAndSplay(sdata.report);
                Object.assign(sdata, obj);
            }

            let balance_report = {};
            if(pressureBalanceId) {
                balance_report = await pressureServiceShell.getPressureBalanceReport({
                    ticket: pressureBalanceId
                })
            }
            

            dispatch(actionGetReportPressureSuccess({
                data: sdata,
                userInfo: res_info.examineeResult,
                balanceReport: balance_report,
            }))
        } catch (error) {
            console.log(error)
        }
        message.destroy()
    }
}

export const ACTION_GETREPORTPRESSURE_SUCCESS = 'USER.ACTION_GETREPORTPRESSURE_SUCCESS'

export interface ActionGetReportPressurePayload {
    data: any
    userInfo: any
    balanceReport: any
}

export const actionGetReportPressureSuccess = createAction(
    ACTION_GETREPORTPRESSURE_SUCCESS,
    (payload: ActionGetReportPressurePayload) => {
        return payload;
    }
)

// 商家 报告列表
export function actionGetReportListEntryMerchant (data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return false;
        }
        message.loading('数据加载中...', 0);
        try {

            let orgId = getState().user.orgId;
            let reqData = {
                pageNum: data.pageNum - 1,
                pageSize: data.pageSize,
                storeIdList: [orgId],
                examinationReportIdList: [],
                mobileNumberList: [],
                nickname: [],
                serialNumberList: [],
            } as any;
            if(data.examinationReportId) {
                reqData.examinationReportIdList = [data.examinationReportId.trim()];
            }
            if(data.mobileNumber) {
                reqData.mobileNumberList = [data.mobileNumber.trim()];
            }
            if(data.nickname) {
                reqData.nickname = [data.nickname.trim()];
            }
            if(data.serialNumber) {
                reqData.serialNumberList = [data.serialNumber.trim()];
            }
            let resScan = await scannerService.pageListReport(reqData)
            
            dispatch(actionGetReportListEntryMerchantSuccess({
                data: resScan
            }))
        } catch (error) {
            console.log(error)
        }
        message.destroy();
    }
}

export const ACTION_GETREPORTLISTENTRYMERCHANT_SUCCESS = 'USER.ACTION_GETREPORTLISTENTRYMERCHANT_SUCCESS'

export interface ActionGetReportListEntryMerchantPayload {
    data: any
}

export const actionGetReportListEntryMerchantSuccess = createAction(
    ACTION_GETREPORTLISTENTRYMERCHANT_SUCCESS,
    (payload: ActionGetReportListEntryMerchantPayload) => {
        return payload;
    }
)

// 商家报告详情
export function actionGetReportDetailEntryMerchant (data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return false;
        }
        message.loading('数据加载中...', 0);
        try {

            let res = await examinationService.getExaminationReportByExamineeReportDetailId({
                examineeReportDetailId: data
            });
            let report = res.examinationReportResult || {};
            if(report.examineeResult && report.examineeResult.accountId) {
                let accountId = report.examineeResult.accountId;
                let res_account = await personalService.getSocialByAccountIds({
                    accountIds: [accountId]
                })
                if(res_account.socialResults.length) {
                    let obj = {
                        ...report,
                        realName: res_account.socialResults[0].realName,
                        social: res_account.socialResults[0]
                    }
                    report = obj;
                }
            }

            if(report) {
                let res_report = await scannerService.getReportByTicket({
                    ticket: report.examineeReportDetailId
                });
                if(res_report.report) {
                    Object.assign(report, {detail: res_report.report})
                }
            }
            
            dispatch(actionGetReportDetailEntryMerchantSuccess({
                data: report
            }))
        } catch (error) {
            console.log(error)
        }
        message.destroy()
    }
}

export const ACTION_GETREPORTDETAILENTRYMERCHANT_SUCCESS = 'USER.ACTION_GETREPORTDETAILENTRYMERCHANT_SUCCESS'

export interface ActionGetReportDetailEntryMerchantPayload {
    data: any
}

export const actionGetReportDetailEntryMerchantSuccess = createAction(
    ACTION_GETREPORTDETAILENTRYMERCHANT_SUCCESS,
    (payload: ActionGetReportDetailEntryMerchantPayload) => {
        return payload;
    }
)


// 根据参数获取模型 stl
export function actionGetReportInsoleModelStl (data, direction) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return false;
        }
        message.loading('数据加载中...', 0);
        let cdata =  _.cloneDeep(data);
        try {

            if(direction === 'left') {
                let sdata = formatGetInsoleModelRequest(cdata.left);
                let res = await scannerService.getInsoleModel(sdata);
                cdata.left.url = res.url;
                cdata.left.id = res.id;
                cdata.left.shoeSize = res.shoeSize;
            }
            else {
                let sdata = formatGetInsoleModelRequest(cdata.right);
                let res = await scannerService.getInsoleModel(sdata);
                cdata.right.url = res.url;
                cdata.right.id = res.id;
                cdata.right.shoeSize = res.shoeSize;
            }
            dispatch(actionGetReportInsoleModelStlSuccess({
                data: cdata
            }))
        } catch (error) {
            console.log(error);
            cdata.right.url = '';
            cdata.left.url = '';
            dispatch(actionGetReportInsoleModelStlSuccess({
                data: cdata
            }))
        }
        message.destroy()
    }
}

export const ACTION_GETREPORTINSOLEMODELSTL_SUCCESS = 'USER.ACTION_GETREPORTINSOLEMODELSTL_SUCCESS'

export interface ActionGetReportInsoleModelStlPayload {
    data: any
}

export const actionGetReportInsoleModelStlSuccess = createAction(
    ACTION_GETREPORTINSOLEMODELSTL_SUCCESS,
    (payload: ActionGetReportInsoleModelStlPayload) => {
        return payload;
    }
)

// 修改报告鞋垫模型参数
export function actionUpdateReportInsoleModel (data, direction, ticket, isDownload: boolean) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return false;
        }
        message.loading('数据保存中...', 0);
        try {

            let request_data: UpdateReportInsoleModelRequest = {
                ticket: ticket,
                footSide: FootSide.LEFT,
                insoleModelId: 0
            }
            let url_download = '';
            if(direction === 'left') {
                let sdata = formatGetInsoleModelToString(data.left);
                data.left = {
                    ...data.left,
                    ...sdata,
                }
                request_data.insoleModelId = data.left.id;
                url_download = data.left.url;
            }
            else {
                let sdata = formatGetInsoleModelToString(data.right);
                data.right = {
                    ...data.right,
                    ...sdata,
                }
                request_data.insoleModelId = data.right.id;
                request_data.footSide = FootSide.RIGHT;
                url_download = data.right.url;
            }

            if(request_data.insoleModelId) {
                // 更新模型id
                await scannerService.updateReportInsoleModel(request_data)
            }
            dispatch(actionUpdateReportInsoleModelSuccess({
                data: data
            }))
            
            message.destroy();
            message.success('保存成功', 6);

            if(isDownload) {
                console.log('下载鞋垫模型', url_download);
                const doc = document.createElement('a');
                doc.setAttribute('href', url_download);
                doc.click();
            }

        } catch (error) {
            message.destroy();
            message.error('保存失败', 6);
            console.log(error)
        }
        // message.destroy()
    }
}

export const ACTION_UPDATEREPORTINSOLEMODEL_SUCCESS = 'USER.ACTION_UPDATEREPORTINSOLEMODEL_SUCCESS'

export interface ActionUpdateReportInsoleModelPayload {
    data: any
}

export const actionUpdateReportInsoleModelSuccess = createAction(
    ACTION_UPDATEREPORTINSOLEMODEL_SUCCESS,
    (payload: ActionUpdateReportInsoleModelPayload) => {
        return payload;
    }
)


// 报告备注 添加修改删除
export function actionOperateReportRemark (data, type, isMerchant) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return false;
        }
        message.loading('备注修改中...', 0);
        try {

            switch (type) {
                case 'add': 
                    await scannerService.addReportRemark(data);
                    break;
                case 'update': 
                    await scannerService.updateReportRemark(data);
                    break;
                case 'delete': 
                    await scannerService.deleteReportRemark(data);
                    break;
            }

            dispatch(actionOperateReportRemarkSuccess({
                data: data
            }))
            
            if(isMerchant) {
                dispatch(actionGetReportDetailEntryMerchant(data.ticket))
            }
            else {
                dispatch(actionGetReportDetailEntryIns(data.ticket))
            }
            message.destroy();
            message.success('保存成功', 6);
        } catch (error) {
            message.destroy();
            message.error('保存失败', 6);
            console.log(error)
        }
        // message.destroy()
    }
}

export const ACTION_OPERATEREPORTREMARK_SUCCESS = 'USER.ACTION_OPERATEREPORTREMARK_SUCCESS'

export interface ActionOperateReportRemarkPayload {
    data: any
}

export const actionOperateReportRemarkSuccess = createAction(
    ACTION_OPERATEREPORTREMARK_SUCCESS,
    (payload: ActionOperateReportRemarkPayload) => {
        return payload;
    }
)